$(document).ready(function() {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *

    var $heroSlider = $(".js-hero-slider");

    if ($heroSlider.length){
        $heroSlider.slick({
            fade: true,
            dots: true,
            arrows: false,
            autoplay: true,
            speed: 1000,
            autoplaySpeed: 8000,
            prevArrow: $(".js-hero-slider-nav-prev"),
            nextArrow: $(".js-hero-slider-nav-next"),
            responsive: []
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * imageSlider
    // *
    // *

    var $imageSlider = $(".js-image-slider");

    if ($imageSlider.length){
        $imageSlider.slick({
            fade: true,
            dots: true,
            arrows: false,
            autoplay: true,
            speed: 1000,
            autoplaySpeed: 8000,
            prevArrow: $(".js-image-slider-nav-prev"),
            nextArrow: $(".js-image-slider-nav-next"),
            responsive: []
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Scroll to top
    // *
    // *

	$(window).scroll(function () {
        if ($(this).scrollTop() > 300) {
            $('.js-scrolltop').fadeIn();
        } else {
            $('.js-scrolltop').fadeOut();
        }
    });

    $('.js-scrolltop').click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, 600);
        return false;
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Scroll-To
    // *
	// * Smooth-Scroll to targets on page

    $(".js-hero-scrolldown").click(function(){
		$('html, body').animate({
		    scrollTop: $(this).offset().top
		}, 1000);
		return false;
	});



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Link in a new window
    // *
    // *

	$('a[rel*="external"]').click(function() {
   		$(this).attr('target','_blank');
   	});



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accodion
    // *
    // *

	$('.accordion__title').click(function() {
        $(this).toggleClass('open');
        $accordion_content = $(this).next('.accordion__content');
        $('.accordion__content').not($accordion_content).slideUp(200);
        $('.accordion__content').not($accordion_content).prev('.accordion__title').removeClass('open');
        $accordion_content.stop(true, true).slideToggle(200);
	});



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * sticky header
    // *
    // *

    $(window).scroll(function() {
        if($(window).scrollTop() >= 10) {
            $(".js-header").addClass("sticky");
            $(".js-contactbar").addClass("hide scroll");
        }else {
            $(".js-header").removeClass("sticky");
            $(".js-contactbar").removeClass("hide scroll");
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * mobile menu
    // *
    // *

    $('.js-mobile').click(function(){
        $('.js-aside').addClass('open');
    });

    $('.js-aside').click(function(){
        $(this).removeClass('open');
    });

});
